import React from 'react'
import styles from './WebsiteDescription.module.scss'

export const WebsiteDescription: React.FC<{ productDescription: string }> = ({
  productDescription
}): JSX.Element => (
  <div className={styles.DescriptionContainer}>{productDescription}</div>
)
